import { createSelector } from '@reduxjs/toolkit';
import type { RootState } from '@/store/types/RootState';

type AuthSlice = RootState['authSlice'];

const selectAuthSlice = (state: RootState) => state?.authSlice;

export const selectAuthSignInIsLoading = createSelector(
  selectAuthSlice,
  (state: AuthSlice) => state?.statuses.signInInProgress || false,
);

export const selectAuthOtpConfigIsLoading = createSelector(
  selectAuthSlice,
  (state: AuthSlice) => state?.statuses.otpConfigIsLoading || false,
);

export const selectAuthForgotUsernameIsLoading = createSelector(
  selectAuthSlice,
  (state: AuthSlice) => state?.statuses.isForgotUsernameInProgress || false,
);

export const selectAuthForgotPasswordIsLoading = createSelector(
  selectAuthSlice,
  (state: AuthSlice) => state?.statuses.isForgotPasswordInProgress || false,
);

export const selectAuthUpdatePasswordIsLoading = createSelector(
  selectAuthSlice,
  (state: AuthSlice) => state?.statuses.isUpdatePasswordInProgress || false,
);

export const selectAuthOtpConfig = createSelector(selectAuthSlice, (state: AuthSlice) => state?.otpConfig || null);
